<template>
  <modal title="View Only Modal" anchor="#view-only" id="view-only" :hide-header="true" :hide-footer="true" @hidden="clearRoute">
    <div class="view-only-content justify-content-md-center text-center mt-5">
      <h4 class="title">Read only account</h4>
      <img class="icon" src="@img/icons-card-actions-compact-read-only.svg">
      <div v-if="pendingRequest" class="copy">Your request for an upgraded license has been sent.</div>
      <div v-else class="copy">Upgrade your license now to share content and create collections.</div>
      <div class="p-20-0">
        <async-block :loading="loading">
          <a v-if="pendingRequest" class="btn cta-bg btn-disabled" disabled="disabled">
            Awaiting license upgrade
          </a>
          <a v-else href="#" id="request-license" class="btn cta-bg" rel="nofollow" @click.prevent="requestLicense" :disabled="pendingRequest" data-testid="request-license">
            Request license upgrade
          </a>
        </async-block>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@cmp/modal';
import AsyncBlock from '@cmp/base/async_block';
import _ from 'lodash';

export default {
  components: { Modal, AsyncBlock },
  data: function(){
    return {
      pendingRequest: false,
      loading: true
    }
  },
  created: function(){
    const vm = this;
    vm.$store.cache.dispatch('getLicenseRequests', gon.currentOrganizationId).then((response) => {
      vm.pendingRequest = _.some(response.data.data.license_requests, (r) => r.attributes.accepted == false);
      vm.loading = false;
    });
  },
  methods: {
    clearRoute: function(){
      this.$router.push({ path: this.$route.path, hash: null });
    },
    requestLicense: function(){
      const vm = this;
      vm.loading = true;
      vm.$store.dispatch('createLicenseRequest', gon.currentOrganizationId).then(() => {
        vm.loading = false;
        vm.pendingRequest = true;
      });
    }
  }
}
</script>

<style lang="scss">
  #view-only___BV_modal_outer_ {
    .modal-dialog {
      max-width: 400px;
    }

    #view-only {
      margin-top: 3rem;

      .icon {
        width: 8rem;
        height: 8rem;
        margin: 2.75rem 4.5rem 1.563rem;
        object-fit: contain;
      }

      .copy {
        max-width: 80%;
        margin: auto;
        font-family: SFPro;
        font-size: 1rem;
        line-height: 1.5;
        text-align: center;
        color: #000000;
      }

      .view-only-content {
        .title {
          font-family: SFPro;
          font-size: 1.5rem;
          font-weight: 600;
          text-align: center;
          font-stretch: normal;
          color: #4a4a4a;
        }
      }

      .cta-bg {
        color: white;
      }
    }
  }
</style>
